module.exports = __webpack_public_path__ + "static/img/01_03.8f6b014.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/alipay/01_03.png
// module id = ZOGa
// module chunks = 1